import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { Creators as ActionsRemetentes, Types } from "ducks/Remetentes";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";
import notify from 'utils/modern_notify';

let mensagemRemententes = {};

const buscarTodosRemetentesRequisicao = async dados =>
    api
        .post(`/api/destinatarios/busca/remetentes`, dados)
        .then(remetentesData => remetentesData)
        .catch(error => error);
const buscarTodosRemetentesRequisicaoNovo = async dados =>
    api
        .get(`/api/negocioempresa/buscar`, dados)
        .then(remetentesData => remetentesData)
        .catch(error => error);

function* buscarRemetentes({ payload }) {
    const { cnpjEmpresa } = payload;
    const dados = {
        cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [cnpjEmpresa]
    };

    let remetentesData = [];
    mensagemRemententes = "";

    try {
        const response = yield call(buscarTodosRemetentesRequisicao, dados);
        if (response.ok) {
            if (response.data.resultado) {
                remetentesData = response.data.valor.map(remetente => ({
                    cnpj: remetente.cnpj_dist || "",
                    nome: remetente.nome_dist || ""
                }));
                yield put(
                    ActionsRemetentes.buscarRemetentesSucesso(remetentesData)
                );
            } else {
                // yield put(
                //     ActionsGeral.setMensagem({
                //         mensagem: "Não foi encontrado nenhum remetente cod[210]"
                //     })
                // );
                notify("Não foi encontrado nenhum remetente",1)
                yield put(
                    ActionsRemetentes.setLoadingRemetentes({ loader: false })
                );
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagemRemententes = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagemRemententes = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(
                ActionsRemetentes.setLoadingRemetentes({ loader: false })
            );
            // yield put(ActionsGeral.mostrarMensagem(mensagemRemententes));
        }
    } catch (error) {
        yield put(ActionsRemetentes.setLoadingRemetentes({ loader: false }));
        // yield put(ActionsGeral.mostrarMensagem(`Erro:${error}`));
    }
}

function* buscarRemetentesNovo({ payload }) {
    const { cnpj, tipo } = payload;
    const dados = {
        cnpj: Array.isArray(cnpj) ? cnpj : [cnpj],
        relacao: "normal",
        tipo
    };

    let remetentesData = [];
    mensagemRemententes = "";

    try {
        const response = yield call(buscarTodosRemetentesRequisicaoNovo, dados);
        if (response.ok) {
            if (response.data.status) {
                remetentesData = response.data.dados;
                yield put(
                    ActionsRemetentes.buscarRemetentesSucessoNovo(
                        remetentesData
                    )
                );
            } else {
                notify("Não foi encontrado nenhum remetente",1)
                yield put(
                    ActionsRemetentes.setLoadingRemetentes({ loader: false })
                );
            }
        } else {
            if (Object.prototype.hasOwnProperty.call(response.data, "error")) {
                switch (response.data.error) {
                    default:
                        mensagemRemententes = `Ocorreu um erro${response.data.error}`;
                        break;
                }
            } else {
                mensagemRemententes = "Ocorreu um erro interno.Tente novamente";
            }
            yield put(
                ActionsRemetentes.setLoadingRemetentes({ loader: false })
            );
            // yield put(ActionsGeral.mostrarMensagem(mensagemRemententes));
        }
    } catch (error) {
        yield put(ActionsRemetentes.setLoadingRemetentes({ loader: false }));
        // yield put(ActionsGeral.mostrarMensagem(`Erro:${error}`));
    }
}

export function* buscarDadosTodosRemetentes() {
    yield takeLatest(Types.BUSCAR_REMETENTES, buscarRemetentes);
}

export function* buscarDadosTodosRemetentesNovo() {
    yield takeLatest(Types.BUSCAR_REMETENTES_NOVO, buscarRemetentesNovo);
}

export default function* rootSaga() {
    yield all([
        fork(buscarDadosTodosRemetentes),
        fork(buscarDadosTodosRemetentesNovo)
    ]);
}
